import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import FileDownload from "components/Varios/FileDownload.js";

export default class CardInformacionFamiliar extends React.Component {

    state = {        
        isOpen: false,
    };
    
    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    transformText(text) {
        var textResult = "";
        if (text)
        {
            var textList = text.split(" ");
            for (var i = 0; i < textList.length; i++) {
                textResult += (textList[i].substring(0, 1).toUpperCase() + textList[i].substring(1, textList[i].length).toLowerCase() + " ");
            }
        }
        return textResult
    }

    download = (e) => {
        e.preventDefault();
        let name = e.target.parentNode.dataset.name;
        let url = e.target.parentNode.dataset.url;
        fetch(url)
            .then(response => {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = name;
                    a.click();
                });
            });
    };


    render() {
        
            return (
                <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                    <Card>
                        <CardBody>
                            <CardText>
                                {
                                    this.props.objeto.esincapacitado === "S" ?
                                        <span style={{ float: "right" }}>
                                            <i className="fas fa-wheelchair" aria-hidden="true" style={{ padding: "5px", fontSize: "18px", backgroundColor: "rgb(255, 194, 0)", color: "#fff" }}></i>
                                        </span>
                                        :
                                        null
                                }

                                <b>{this.transformText(this.props.objeto.nombres + " " + this.props.objeto.apellidos)}</b>
                                <br />
                                <br />
                                <span className="spanCard">F. NACIMIENTO: </span>{this.parseDate(this.props.objeto.fechanacimiento)}
                                <br />
                                <span className="spanCard">IDENTIFICACIÓN: </span>{this.props.objeto.numeroidentificacion}
                                <br />
                                <span className="spanCard">PARENTESCO: </span>{this.props.objeto.strNombreParentesco}
                                <br />
                                <span className="spanCard">INSTRUCCIÓN: </span>{this.props.objeto.strNivelInstruccion}
                                {
                                    this.props.objeto.esincapacitado === "S" && this.props.objeto.discapcarnet ?
                                        <>
                                            <br />
                                            <br />
                                            <span style={{ color: "#547BBD", margin: "0px", display: "inline", fontStyle: "italic" }}>DATOS DE DISCAPACIDAD</span>
                                            <br />
                                            <span className="spanCard">TIPO: </span>{this.props.objeto.strNombreTipoDiscapacidad}
                                            <br />
                                            <span className="spanCard">PORCENTAJE: </span>{this.props.objeto.discapporc} %
                                            <br />
                                            <span className="spanCard">CARNET CONADIS: </span>{this.props.objeto.discapcarnet}
                                            <br />
                                            <span className="spanCard">FECHA EMISIÓN: </span>{this.parseDate(this.props.objeto.fechaemisiondiscap)}
                                            <br />
                                            <span className="spanCard">FECHA VENCIMIENTO: </span>{this.parseDate(this.props.objeto.fechacaducidaddiscap)}

                                            {this.props.objeto.essustitutolegal === "S" && this.props.objeto.numerocertsustituto ?
                                                <>
                                                    <br />
                                                    <br />
                                                    <span style={{ color: "#547BBD", margin: "0px", display: "inline", fontStyle: "italic" }}>DATOS DE SUSTITUCIÓN</span>
                                                    <br />
                                                    <span className="spanCard"># CERTIFICACIÓN: </span>{this.props.objeto.numerocertsustituto}
                                                    <br />
                                                    <span className="spanCard">FECHA EMISIÓN: </span>{this.parseDate(this.props.objeto.fechaemisioncertsustituto)}
                                                    <br />
                                                    <span className="spanCard">FECHA VENCIMIENTO: </span>{this.parseDate(this.props.objeto.fechacaducidadcertsustituto)}
                                                </>
                                                :
                                                null
                                            }
                                        </>
                                       :
                                        null
                                }
                                

                            </CardText>
                        </CardBody>
                        <CardFooter className="text-muted">
                            <div style={{ float: "left" }}>
                                {this.props.number}
                            </div>
                            <div style={{ float: "right" }}>
                                {/*<FileDownload files={this.props.evidencias} card={true} icon="download" />*/}
                                {this.props.evidencias.map((evidencia, idx) =>
                                    <CardLink onClick={this.download} data-name={evidencia.name} data-url={evidencia.url} key={idx} href="#"><i className="fas fa-download" aria-hidden="true"></i></CardLink>
                                )}
                                <CardLink onClick={this.props.eventEdit} href="#"><i className="fas fa-edit" aria-hidden="true"></i></CardLink>
                                <CardLink onClick={this.toggle} href="#"><i className="fas fa-trash-alt" aria-hidden="true"></i></CardLink>
                            </div>
                        </CardFooter>
                    </Card>
                    <Modal isOpen={this.state.isOpen} fade={false} toggle={this.toggle} >

                        <ModalBody>
                            ¿Está seguro que desea eliminar el registro?
                        </ModalBody>
                        <ModalFooter>
                            <Button color="secondary" onClick={change => this.onClick(change)}>Aceptar</Button>{' '}
                            <Button color="primary" onClick={this.toggle}>Cancelar</Button>
                        </ModalFooter>

                    </Modal>
                </div>
            )

    }
}